// CRO fix Oct 2026: keep a local reference so the call can't fail if window.theme is replaced by another script
var osgsWishlist = function () {
  var $wishlistButton = $('.wishlist-btn');
  var $wishlistTile = $('.wishlist-grid');
  var wishlist = localStorage.getItem('user_wishlist') || [];

  if (wishlist.length > 0) {
    if (localStorage.getItem('user_wishlist') === null) {
      wishlist = [];
    } else {
      wishlist = JSON.parse(localStorage.getItem('user_wishlist'));
    }

    $('.wishlist_count').html(parseInt(wishlist.length));
  }

  /*
   * Update button to show current state (gold for active)
   */   
  var animateWishlist = function (self) {
    $(self).toggleClass('is-active');
  };

  /*
   * Add/Remove selected item to the user's wishlist array in localStorage
   * Wishlist button class 'is-active' determines whether or not to add or remove
   * If 'is-active', remove the item, otherwise add it
   */   
  var updateWishlist = function (self) {
    var productHandle = $(self).attr('data-product-handle');
    var isRemove = $(self).hasClass('is-active');
    /* Remove */
    if (isRemove) {
      var removeIndex = wishlist.indexOf(productHandle);
      wishlist.splice(removeIndex, 1);
      $(self).closest($wishlistTile).remove();
      localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
    }
    /* Add */ 
    else {
      wishlist.push(productHandle);
      localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
    }
  };

  /*
   * Loop through wishlist buttons and activate any items that are already in user's wishlist
   * Activate by adding class 'is-active'
   * Run on initialization
   */   
  var activateItemsInWishlist = function () {
    $wishlistButton.each(function () {
      var productHandle = $(this).attr('data-product-handle');
      if (wishlist.indexOf(productHandle) > -1) {
        $(this).addClass('is-active');
      }
    });
  };

  /*
   * Loop through product titles and remove any that aren't a part of the wishlist
   */   
  var displayOnlyWishlistItems = function () {
    $wishlistTile.each(function () {
      var productHandle = $(this).attr('data-product-handle');
      if (wishlist.indexOf(productHandle) === -1) {
        $(this).remove();
      }
    });
  };

  /*
   * Check if on the wishlist page and hide any items that aren't a part of the wishlist
   * If no wishlist items exist, show the empty wishlist notice
   */   
  var loadWishlist = function () {
    if (window.location.href.indexOf('/pages/wishlist') > -1) {
      displayOnlyWishlistItems();
      $('.wishlist-loader').fadeOut(2000, function () {
        $('.wishlist_container').removeClass('d-none');
        
        var currentWishlistArr = JSON.parse(localStorage.getItem('user_wishlist'));
        
        if(currentWishlistArr == null) {
          var currentWishlistItemCount = 0;
        } else {
          var currentWishlistItemCount = parseInt(currentWishlistArr.length);
        }
        
        if (currentWishlistItemCount == 0) {
          $('.wishlist_container').addClass('no_wishlist_items');
        } else {
          $('.wishlist_container').removeClass('no_wishlist_items');
        }
      });
    }
  };

  var bindUIActions = function () {
    $wishlistButton.click(function (e) {
      e.preventDefault();
      updateWishlist(this);
      animateWishlist(this);

      setTimeout(function(){
        var currentWishArr = JSON.parse(localStorage.getItem('user_wishlist'));
        var currentWishItemCount = parseInt(currentWishArr.length);

        $('.wishlist_count').html(currentWishItemCount);

        if (currentWishItemCount == 0) {
          $('.wishlist_container').addClass('no_wishlist_items');
        } else {
          $('.wishlist_container').removeClass('no_wishlist_items');
        }       
      }, 300)
    });
  };


  bindUIActions();
  activateItemsInWishlist();
  loadWishlist();
};

window.theme = window.theme || {};
window.theme.wishlist = osgsWishlist;
osgsWishlist();